'use strict';

/* $ */
/* _ */
/* global Backbone */
/* Marionette */

let basketRadio = Backbone.Radio.channel('basket');

class ProductModel extends Backbone.Model {
    defaults() {
        return {
            count: 0,
            price: 0,
            summ: 0,
            product_id: undefined,
            is_in_basket: false,
            is_progress: false,
            can_add_to_basket: false
        };
    }
    initialize() {
        let self = this;
        self.listenTo(basketRadio, 'changed:in:basket', self.checkProductIsAdded);
        self.listenTo(basketRadio, 'removed:from:basket', self.checkProductIsRemoved);
        self.listenTo(self, 'change:count', self.changeSumm);
        self.listenTo(self, 'change:count', self.checkCanAddToBasket);
        self.listenTo(self, 'is:ready', function(){
            self.checkCanAddToBasket();
            self.changeSumm();
        });
    }
    changeSumm() {
        let self = this;
        self.set('summ', self.get('price') * self.get('count'));
    }
    checkCanAddToBasket(){
        let self = this;
        if((self.get('count') > 0) || (self.get('is_in_basket'))){
            self.set('can_add_to_basket', true);
        }else{
            self.set('can_add_to_basket', false);
        }
    }
    checkProductIsAdded(product){
        let self = this;
        if(self.get('product_id') == product.product_id){
            self.set({
                count: product.count,
                is_progress: false,
                is_in_basket: true
            });
        }
    }
    checkProductIsRemoved(product){
        let self = this;
        if(self.get('product_id') == product.id){
            self.set({
                count: 0,
                is_progress: false,
                is_in_basket: false
            });
            self.trigger('is:removed');
        }
    }
    addToBasket(){
        let self = this;
        self.set('is_progress', true);
        basketRadio.trigger('add:to:basket', self);
    }
    removeFromBasket(){
        let self = this;
        self.set('is_progress', true);
        basketRadio.trigger('remove:from:basket', self);
    }
}

class ProductCollection extends Backbone.Collection {
    model() {
        return ProductModel;
    }
}

export {
    ProductModel,
    ProductCollection
};
